const TokenKey = "Token";

export function getToken() {
    return localStorage.getItem(TokenKey);
}

export function setToken(token) {
    return localStorage.setItem(TokenKey, token);
}

export function removeToken() {
    return localStorage.removeItem(TokenKey);
}

export function getName() {
    return localStorage.getItem("name");
}

export function setName(name) {
    return localStorage.setItem("name", name);
}

export function removeName() {
    return localStorage.removeItem("name");
}

export function getUserPhone() {
    return localStorage.getItem("userPhone");
}

export function setUserPhone(userPhone) {
    return localStorage.setItem("userPhone", userPhone);
}

export function removeUserPhone() {
    return localStorage.removeItem("userPhone");
}